import styled from 'styled-components';
import { shade } from 'polished';

export const Container = styled.button`
  background: #2196f3;
  border-radius: 10px;
  border: 0;
  font-weight: 600;
  color: #fff;
  width: 100%;
  height: 56px;
  padding: 0 16px;
  margin-top: 16px;
  transition: background-color 0.2s;

  &:hover {
    background: ${shade(0.2, '#2196f3')};
  }

  :disabled {
    background: #2196f3; // #eceff1;
    color: #90a4ae;
    transition: background-color 0.2s;
    cursor: no-drop;
  }

  @media (max-width: 600px) {
    width: 100%;
    height: 45px;
    padding: 0 16px;
  }
`;
